import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';

import EditConfig from './submodules/edit';
import { FINANCE_RESOURCES } from '../../helper';
import { GET_ACTION, TDS_ABSORPTION_RESOURCES } from '../tdsHelper';

const TdsConfigDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={FINANCE_RESOURCES.tdsAbsorption}
				configResourceName={TDS_ABSORPTION_RESOURCES.tdsAbsorptionConfigs}
				configActionName={GET_ACTION.tdsAbsorptionConfigs.updateTDSAbsorptionConfigs}
				path={`${path}/edit`}
				component={EditConfig}
				exact
			/>
			<Redirect to={`${path}/edit`} />
		</Switch>
	);
};

export default TdsConfigDashboard;
